import { useFormik } from "formik";
import { validationSchema } from "../validations/validationsPartnerErrors";

export const useFormRCSPartnerErrorsLog = ({ onSubmit }) => {
  return useFormik({
    initialValues: {
      period: {
        dateFrom: "",
        dateTo: "",
      },
      partner: ""
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const dataToSubmit = {
        from: values?.period?.dateFrom,
        to: values?.period.dateTo,
        partner: values?.partner,
      };

      onSubmit(dataToSubmit);
    },
  });
};
